import { Component, Input } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
	selector: 'app-error-modal',
	templateUrl: './error-modal.component.html',
	styleUrls: ['./error-modal.component.scss'],
	standalone: true,
	imports: [DialogModule]
})
export class ErrorModalComponent {
	@Input() title = 'Error';
	@Input() description = 'Ha ocurrido un error';
	visible = false;

	show(title: string, description: string) {
		this.title = title;
		this.description = description;
		this.visible = true;
	}
}
